import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import InstagramAuth from 'Src/pages/InstagramAuth';
import Defaulter from 'Src/pages/Defaulter';
import Pager from 'Src/components/Pager';

const styles = {
  v1: () => import('Src/styles/main.less'),
  v2: () => import('Src/styles/main.less'),
  v3: () => import('Src/styles/main.less'),
  guelph: () => import('Src/styles/guelph/main.less'),
  wreats: () => import('Src/styles/main.less'),
  concierge: () => import('Src/styles/main.less'),
  'bpp-all': () => import('Src/styles/main.less'),
  yaa: () => import('Src/styles/main.less'),
};

const versions = {
  v1: () => import('./v1'),
  v2: () => import('./v2'),
  v3: () => import('./v3'),
  guelph: () => import('./v4-guelph'),
  wreats: () => import('./v4-wreats'),
  concierge: () => import('./v5-concierge'),
  'bpp-all': () => import('./v6-bpp-all'),
  yaa: () => import('./yaa'),
};


const Version = (props) => {
  const [steps, setSteps] = useState([]);

  const { match = {} } = props;
  const { path } = match;
  const { params = {} } = match;
  const { version = 'v1' } = params;

  const loadVersionSteps = async () => {
    const { [version]: resolver } = versions;
    const { [version]: styleResolver } = styles;
    await styleResolver();
    const stepsModule = await resolver();
    const { default: newSteps = [] } = stepsModule;
    setSteps(newSteps);
  };

  useEffect(() => {
    loadVersionSteps();
  }, []);

  return (
    <Switch>
      <Route
        exact
        path={path}
      >
        <Pager
          version={version}
          {...{ steps }}
          {...props}
        />
      </Route>

      <Route
        exact
        path={`${path}/callback/instagram`}
        component={InstagramAuth}
      >
        <InstagramAuth
          {...{ steps }}
          {...props}
        />
      </Route>

      <Route
        exact
        path={`${path}/default`}
        component={Defaulter}
      />
    </Switch>
  );
};

export default Version;
